import { render } from "./PropertyHome.vue?vue&type=template&id=47a0a7f8"
import script from "./PropertyHome.vue?vue&type=script&lang=js"
export * from "./PropertyHome.vue?vue&type=script&lang=js"

import "./PropertyHome.vue?vue&type=style&index=0&id=47a0a7f8&lang=scss"

import exportComponent from "/var/app/current/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__